const debug = false

const datos = {
    urlapi: debug === true ? 'http://localhost:80/api/1.0' : 'https://bilingual.laguna-demo-apps.click/api/1.0',
    key_local_storage_user: 'bilingual_bknd_user',
    key_local_storage_cart: 'bilingual_bknd_cart',
    pagina: 20,
}

module.exports = datos